"use client";

import { useEffect, useState } from "react";
import InboxIcon from "@mui/icons-material/Inbox";
import { adminFetch } from "@/helpers/firebase/admin-fetch";
import styles from "./Navbar.module.css";

// "Inbox" at the top of the admin sidebar, for super admins only. The server
// decides (/api/admin/inbox/me); regular admins never see it.
export default function InboxNavItem({ selected, onOpen }: { selected: boolean; onOpen: () => void }) {
  const [state, setState] = useState<{ superAdmin: boolean; count: number | null }>({ superAdmin: false, count: null });

  useEffect(() => {
    let active = true;
    adminFetch("/api/admin/inbox/me")
      .then((r) => (r.ok ? r.json() : null))
      .then((me) => {
        if (active && me?.superAdmin) setState({ superAdmin: true, count: me.needsReply ?? null });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!state.superAdmin) return null;
  return (
    <div className="cursor-pointer flex justify-start items-center py-2" onClick={onOpen}>
      <InboxIcon width={20} height={20} style={{ color: selected ? "#333E48" : "#909090" }} />
      <span
        className={`ml-3 text-sm ${selected ? "font-bold text-black" : `font-normal text-custom-gray2 ${styles.unselectedMenuItem}`}`}
      >
        Inbox
      </span>
      {state.count ? (
        <span className="ml-auto rounded-full bg-[#333E48] px-2 py-0.5 text-[11px] font-semibold text-white">{state.count}</span>
      ) : null}
    </div>
  );
}
